export default __webpack_public_path__ + "static/media/logo4.32cdf889.png";